// @mui
import { Alert, Snackbar } from '@mui/material';
// utils

// ----------------------------------------------------------------------

export default function Notification({ notification, setNotification }) {
    const vertical = 'top'
    const horizontal = 'right'

    const handleClose = () => {
        setNotification({ open: false, msg: "", type: "" })
    }

    return (

        <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={notification.open && notification.msg !== "The server returned an invalid response."}
            autoHideDuration={2000}
            onClose={() => handleClose()}
            key={vertical + horizontal}
        >
            <Alert onClose={handleClose} severity={notification.type === "" ? "success" : notification.type} sx={{ width: '100%' }}>
                {notification.msg}
            </Alert>
        </Snackbar>
    );
}

